import { render, staticRenderFns } from "./CompanyGroupDetail.vue?vue&type=template&id=3bedb403&scoped=true&"
import script from "./CompanyGroupDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyGroupDetail.vue?vue&type=style&index=0&id=3bedb403&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bedb403",
  null
  
)

export default component.exports